Vue.component('screen-sharing', {
	template: '<div v-if="isActive">screen-sharing</div>',
	data:function(){
		return {
			isActive:false,
		}
	},
})
